const STRUCTURED_DATA_IMAGE_DIMENSIONS = 'h_1024';

const escapeScriptClose = (json: string): string => json.replace(/</g, '\\u003c');

type StructuredDataNode = Record<string, unknown> & { hasVariant?: unknown };

const withImage = <T extends StructuredDataNode>(node: T, imageUrl: string | undefined): T =>
  Object.fromEntries(
    Object.entries({ ...node, image: imageUrl }).filter(
      ([key, value]) => key !== 'image' || value !== undefined
    )
  ) as T;

/**
 * FS-4861: the schema.org image is set here rather than in GraphQL, so it is the first PDP gallery
 * image, the same source as og:image.
 */
export const withGalleryImage = (
  structuredData: string,
  galleryImageUrl: string | undefined
): string => {
  let parsed: StructuredDataNode;

  try {
    parsed = JSON.parse(structuredData);
  } catch {
    return escapeScriptClose(structuredData);
  }

  if (!parsed || typeof parsed !== 'object') {
    return escapeScriptClose(structuredData);
  }

  const imageUrl =
    galleryImageUrl?.replace('{{dimensions}}', STRUCTURED_DATA_IMAGE_DIMENSIONS) || undefined;

  const result = withImage(parsed, imageUrl);

  if (Array.isArray(result.hasVariant)) {
    result.hasVariant = result.hasVariant.map(variant =>
      variant && typeof variant === 'object' ? withImage(variant, imageUrl) : variant
    );
  }

  return escapeScriptClose(JSON.stringify(result));
};
